import styled, { css } from "styled-components";
import { AvailableKey, BankHolidayKey, CollectionKey, CollectionReturnKey, ReturnCollectionKey, ReturnKey, SelectedKey, UnavailableKey } from "./KeyColours";

export const KeyContainer = styled.div`
    display:flex;
    justiy-content:center;
    flex-wrap:wrap;
`;
export const KeyBoxItem = styled.div`
    margin:1vw;
`;
export const KeyBoxStyle = css`
    margin: 0.3vw;
    height: 20px;
    width: 60px;
    border: 1px solid var(--main-grey-color);
    @media (min-width: 640px) {
        height: 30px;
        width: 100px;
    }
`;
export const Available = styled.div`
    ${KeyBoxStyle}
    ${AvailableKey(false)}
`;
export const Unavailable = styled.div`
    ${KeyBoxStyle}
    ${UnavailableKey}
`;
export const BankHoliday = styled.div`
    ${KeyBoxStyle}
    ${BankHolidayKey}
`;
export const Selected = styled.div`
    ${KeyBoxStyle}
    ${SelectedKey}
`;
export const CollectionDate = styled.div`
    ${KeyBoxStyle}
    ${CollectionKey(true)}
`;
export const CollectionReturn = styled.div`
    ${KeyBoxStyle}
    ${CollectionReturnKey}
`;
export const ReturnCollection = styled.div`
    ${KeyBoxStyle}
    ${ReturnCollectionKey}
`;
export const ReturnDate = styled.div`
    ${KeyBoxStyle}
    ${ReturnKey(true)}
`;
export const KeyBoxDesc = styled.p`
    font-family: Poppins-SemiBold;
    font-size: 0.8em;
    text-align:center;
    @media (min-width: 640px) {
        font-size: 1em;
    }
`;